import i18n from '@/plugins/i18n';

const t = (key: string) => i18n.global.t(key);

export default {
  required: (value: any) => !!value || t('validation.required'),
  choice2: (value: any) => value.length === 2 || t('validation.choice2'),
  counter: (value: any) => value.length <= 20 || t('validation.counter'),
  counter100: (value: any) => (!value || typeof(value) === 'string' && value.length <= 100)|| t('validation.counter100'),
  counter500: (value: any) => (!value || typeof(value) === 'string' && value.length <= 500) || t('validation.counter500'),
  counter1000: (value: any) => (!value || typeof(value) === 'string' && value.length <= 1000) || t('validation.counter1000'),
  typeNumber: (value: any) => (!value || typeof(value) === 'number' && value < -2147483648 && value > 2147483647) || t('validation.typeNumber'),
  email: (value: any) => {
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return pattern.test(value) || t('validation.email');
  },
  phoneNumber: (value: any) => {
    if (value === null || value === '') { return true; }
    const pattern = /0\d{1,4}-\d{1,4}-\d{4}/;
    return pattern.test(value) || t('validation.phoneNumber');
  },
  postalCode: (value: any) => {
    if (value === null || value === '') { return true; }
    const pattern = /[0-9]{3}-[0-9]{4}/;
    return pattern.test(value) || t('validation.postalCode');
  },
  integerThan0: (value: any) => {
    const pattern = /^\d*$/;
    return pattern.test(value) || t('validation.integerThan0');
  },
  multipleSelectRequired: (value: []) => value.length > 0 || t('validation.multipleSelectRequired'),
};
